module.exports = __webpack_public_path__ + "img/uk_failure_5.eb032fad.png";